import React, { useEffect, useState } from 'react'
import { Button, Drawer, Form, Input, Select, Space } from 'antd'

import { AxiosResponse } from 'axios'
import { Notification } from '../notification'
import {
  getCategoriaProdutos,
  postCategoriaProdutos,
  putCategoriaProdutos,
  TypeCategoriaProdutos,
} from '../../services/categoriaProdutos'
import { tiposSistema } from '../../services/Afins'
import { destroyAlert, errorAlert, loadingAlert, successAlert } from '../../utils/alert'

interface TypesCatProdutos {
  open: boolean
  update: number
  onClose: (data: boolean) => void
}

const FormCatProdutos: React.FC<TypesCatProdutos> = (props) => {
  const { open, update, onClose } = props

  const [form] = Form.useForm()

  const [dataGrupoCatProdutos, setDataTipos] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)

  const listTipos = async () => {
    const resp = await tiposSistema(19)

    setDataTipos(resp)
  }

  const editAtivo = async (cod) => {
    loadingAlert({msg: 'Carregando categoria...', id: 'load_cat_produto'})
    const resp: AxiosResponse<TypeCategoriaProdutos> = await getCategoriaProdutos({ cod })

    form.setFieldsValue(resp.data.itens[0])
    destroyAlert('load_cat_produto')
  }

  const hancleDrawerClose = () => {
    onClose(false)
    form.resetFields()
  }

  const onFinish = async (data) => {
    try {
      loadingAlert({msg: 'Salvando...', id: 'cat_produto'})
      if (update <= 0) {
        const resp = await postCategoriaProdutos(data)

        if (resp.status === 201) {
          successAlert('Categoria salva com sucesso!', 5000, 'cat_produto');
          onClose(true)
          form.resetFields()
        }
      } else {
        const resp = await putCategoriaProdutos(update, data)

        if (resp.status === 200) {
          successAlert('Categoria atualizada com sucesso!', 5000, 'cat_produto');
          onClose(true)
        }
      }
    } catch (error) {
      
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha ao registrar categoria!')
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha ao registrar categoria!')
          })
        }
      }
    }
  }

  useEffect(() => {
    setOpenDrawer(open)
  }, [open])

  useEffect(() => {
    if (update > 0) {
      editAtivo(update)
    }
  }, [update])

  useEffect(() => {
    listTipos()
  }, [])

  return (
    <Form form={form} onFinish={onFinish} layout='vertical'>
      <Drawer
        placement='left'
        style={{ position: 'absolute' }}
        getContainer={false}
        open={openDrawer}
        closeIcon={false}
        onClose={() => hancleDrawerClose()}
        footer={
          <Space>
            <Button type='primary' htmlType='submit'>
              Salvar
            </Button>
            <Button type='primary' danger onClick={() => hancleDrawerClose()}>
              Fechar
            </Button>
          </Space>
        }
      >
        <Form.Item label='Nome' name='nome'>
          <Input />
        </Form.Item>
        <Form.Item label='Tipo' name='cod_grupo'>
          <Select>
            {dataGrupoCatProdutos?.map((data) => (
              <Select.Option key={data.cod} value={data.cod}>
                {data.nome}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Drawer>
    </Form>
  )
}

export default FormCatProdutos
